import { render, staticRenderFns } from "./PreOrder.vue?vue&type=template&id=2b5eccdc&scoped=true&"
import script from "./PreOrder.vue?vue&type=script&lang=js&"
export * from "./PreOrder.vue?vue&type=script&lang=js&"
import style0 from "./PreOrder.vue?vue&type=style&index=0&id=2b5eccdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5eccdc",
  null
  
)

export default component.exports